/** スマートフォン判定に使用する最大画面幅 */
export const MOBILE_MAX_WIDTH = 768;

/** タブレット判定に使用する最大画面幅 */
export const TABLET_MAX_WIDTH = 1024;
